<template>
    <div class="section-posts2 section-posts-list-view">
        <div class="navigations">
            <div class="navigation-status">
                <div class="btn-radius" :class="{active : statusIsAllSelected}" @click="()=>clickStatusEvent('all')">Tous</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.draft}" @click="()=>clickStatusEvent('draft')">Brouillon</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.scheduled}" @click="()=>clickStatusEvent('scheduled')">Planifié</div>
                <div class="btn-radius" :class="{active : !statusIsAllSelected && filter.statusDisplay.posted}" @click="()=>clickStatusEvent('posted')">Posté</div>
                <div class="btn-radius icon" @click.stop="filterIsOpen = true"><i class="fa-solid fa-plus"></i></div>
            </div>
            <div class="navigation-filter">
                <div class="btn-radius search-bar">
                    <div class="svg"><svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none"><path d="M17.0625 8.53125C17.0625 10.4139 16.4514 12.1529 15.4219 13.5639L20.6145 18.7605C21.1271 19.2732 21.1271 20.1059 20.6145 20.6186C20.1018 21.1312 19.2691 21.1312 18.7564 20.6186L13.5639 15.4219C12.1529 16.4555 10.4139 17.0625 8.53125 17.0625C3.81855 17.0625 0 13.2439 0 8.53125C0 3.81855 3.81855 0 8.53125 0C13.2439 0 17.0625 3.81855 17.0625 8.53125ZM8.53125 14.4375C9.30687 14.4375 10.0749 14.2847 10.7915 13.9879C11.5081 13.6911 12.1592 13.256 12.7076 12.7076C13.256 12.1592 13.6911 11.5081 13.9879 10.7915C14.2847 10.0749 14.4375 9.30687 14.4375 8.53125C14.4375 7.75563 14.2847 6.9876 13.9879 6.27103C13.6911 5.55445 13.256 4.90335 12.7076 4.3549C12.1592 3.80645 11.5081 3.3714 10.7915 3.07459C10.0749 2.77777 9.30687 2.625 8.53125 2.625C7.75563 2.625 6.98761 2.77777 6.27103 3.07459C5.55445 3.3714 4.90335 3.80645 4.3549 4.3549C3.80645 4.90335 3.3714 5.55445 3.07459 6.27103C2.77777 6.9876 2.625 7.75563 2.625 8.53125C2.625 9.30687 2.77777 10.0749 3.07459 10.7915C3.3714 11.5081 3.80645 12.1592 4.3549 12.7076C4.90335 13.256 5.55445 13.6911 6.27103 13.9879C6.98761 14.2847 7.75563 14.4375 8.53125 14.4375Z" fill="#E3D2EE"></path></svg></div>
                    <input placeholder="Recherche de publication..." v-model.lazy="filter.search">
                </div>
                <div class="btn-radius" :data-count="filterCount" @click.stop="filterIsOpen = true">
                    Filtrer  
                    <FilterNavigation v-if="filterIsOpen" @close="filterIsOpen = false" :filter.sync="filter" :hideSearchBar="true"/>
                </div>
                <div class="btn-radius icon" @click="fetchPost"><i class="fa-solid fa-rotate-right"></i></div>
            </div>
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected"/>
        </div>

        <div class="list-posts">
            <div class="loading-overlay" v-if="isLoading"><i class="fa-sharp fa-solid fa-spinner-third"></i>Chargement</div>
            <div v-for="(event, id) in eventsFilter" :class="event.status" @click="()=>showPost(id)" class="item-post carousel card-status-background-color card-status-border-color card-status-border-style-default hover-card-status-background-color">
                <div class="post-content">
                    <div class="post-image" v-if="event.image">
                        <img :src="event.image">
                    </div>
                    <div class="container-info-text">
                        <div class="container-date">
                            <p class="date">{{ event.formatedDate }}</p>
                        </div>
                        <p class="content">
                            {{ event.content }}
                        </p>
                    </div>
                </div>  
                   
                <div class="pages">
                    <!-- <Avatar v-for="page in allPages.sort(() => 0.5 - Math.random()).slice(0, Math.floor(Math.random() * 6) + 1)" :urlPicture="page.avatar" :typeNetwork="page.network" :key="page.id" @click="()=>removePage(page.id)"></Avatar> -->
                    <Avatar :urlPicture="event.page.avatar" :typeNetwork="event.page.network" :key="event.page.id"></Avatar>
                </div>
                <div class="container-badge-status">
                    <div class="badge-status" :status="event.status">{{ $t(`dash.post.${event.status}`) }}</div>
                </div>  
            </div>
        </div>

        <DrawerPost 
            v-if="eventIdSelected" 
            :event="events[eventIdSelected]"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
    </div>
</template>


<script>
    import Store from '@/store'
    import MainNavigation from './components/MainNavigation.vue'
    import Avatar from '@/components/dash/utils/avatar.vue'
    import postMixins from '@/components/mixins/Posts.vue'
    import draftMixins from '@/components/mixins/Drafts.vue'
    import sectionPostMixins from './mixins/main.js'
    import FilterNavigation from './components/Filter.vue'
    import DrawerPost from './components/DrawerPost.vue'
    import { convertOldDraft, patchDraft } from './utils/draft.js';
    export default {
        components: {
            MainNavigation,
            Avatar,
            FilterNavigation,
            DrawerPost
        },

        mixins: [postMixins,draftMixins,  sectionPostMixins],

        props: {
            tabSelected: String
        },
        data() {
            return {
                isLoading: true,
                events : {},

                filterIsOpen: false,
                filter: {
                    search: '',
                    statusDisplay:  {
                        all: true,
                        scheduled: true,
                        posted: true,
                        draft: true,
                        pending: true,
                        failed: true,
                        removed: true,
                        standby: true,
                        awaiting_approval: true,
                        to_validate: true,
                    },
                    typesDisplay:  {
                        carousel: true,
                        document: true,
                        reel: true,
                        video: true,
                        image: true,
                        story: true,
                    },
                },
                eventIdSelected:null
            }
        },
        mounted () {
            this.fetchPost()

            if (localStorage.getItem("filterList")) {
                this.filter = JSON.parse(localStorage.getItem("filterList"))
            }
        },

        methods: {
            async fetchPost(){

                this.isLoading = true
                const {body} = await this.postsByPages(
                    this.pagesSelected.map(p=>p.id).join(','), 
                    1000
                )
                this.events = {}
                const events = {}
                for (const post of body.posts.reverse()) {
                    post.draft = {data : {}}
                    const event = await this.buildEvent(post);
                    if (event) {
                        
                        events[event.id] = event;

                        //storifcation ?
                        if (
                            event.page.network == "instagram" && 
                            event.originalPost.page.length &&
                            event.originalPost.page[0].new_story_creation
                        ) {
                            console.log('trouvé storification')
                            const eventStorification = {...event}
                            eventStorification.id = eventStorification.id + "_storification"
                            eventStorification.type = 'story'
                            eventStorification.content = 'Storification'
                            events[eventStorification.id] = eventStorification;
                        }
                    }
                }
                this.events = events
                this.isLoading = false
            },

            async showPost(eventId) {
                console.log('showPost', this.events[eventId])
                
                if (this.events[eventId]) {
                    this.isLoading = true
                    if (this.events[eventId].draft && Object.keys(this.events[eventId].draft).length) {
                        this.eventIdSelected = eventId
                    }else{
                        let body
                        if (this.events[eventId].status == "draft") {
                            const reponse = await this.findDraft(this.events[eventId].originalPost._bots[0].id, this.events[eventId].originalPost._id)
                            body = reponse.body
                        }else{
                            const reponse = await this.findPost(this.events[eventId].originalPost._bots[0].id, this.events[eventId].originalPost.id, this.events[eventId].originalPost.page[0].post_number)
                            body = reponse.body
                        }

                        const event = await this.buildEvent({
                            ...this.events[eventId].originalPost,
                            ...body.post
                        });
                
                        this.events[event.id] = event
                        this.eventIdSelected = event.id
                    }

                    if (this.events[eventId].draft && !this.events[eventId].draft.saveAllFormData) {
                        console.log("handleEventClick",this.events[eventId].draft)
                        const pages = this.events[eventId].originalPost.page && this.events[eventId].originalPost.page[0].posts_multipages ? 
                            this.events[eventId].originalPost.page[0].posts_multipages.map(({page}) => page) : 
                            [this.events[eventId].page.id]

                        const draft = await convertOldDraft(JSON.parse(JSON.stringify(this.events[eventId].draft)), pages)
                        
                        this.$set(this.events[eventId], 'draft', draft)
                        
                    }
                    patchDraft(this.events[eventId].draft)
                
                    this.isLoading = false
                }
            },

            closeDrawer() {
                this.eventIdSelected = null
                // this.getPlannerData()
            },

            clickStatusEvent(name){

                if (name == 'all') {
                    for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                        this.filter.statusDisplay[statusName] = true
                    }
                }else{
                    for (const [statusName, bool] of Object.entries(this.filter.statusDisplay)) {
                        this.filter.statusDisplay[statusName] = false
                    }
                    this.filter.statusDisplay[name] = true // this.filter.typesDisplay[name] ? false : true
                }
             
            }
            
        },
        computed: {
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'];
            },
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },

            eventsFilter() {
                let isSearchBarMatching;
                let count = 0
                let searchValue = this.filter.search.toLowerCase()
                return Object.entries(this.events).reduce((acc, [key, event]) => {
                   
                    isSearchBarMatching = !searchValue || (event.content && event.content.toLowerCase().includes(searchValue))
                    if ((this.filter.statusDisplay[event.status]) && isSearchBarMatching && (!event.type || this.filter.typesDisplay[event.type])) {
                        
                        if (count < 100) {
                            count++
                            acc[key] = event
                        }
                    }
                    return acc;
                }, {});
            },

            filterCount() {
                return (this.filter.search ? 1 : 0) + (Object.values(this.filter.statusDisplay).includes(false) ? 1 : 0) + (Object.values(this.filter.typesDisplay).includes(false) ? 1 : 0)
            },

            statusIsAllSelected() {
                return !Object.values(this.filter.statusDisplay).includes(false)
            }
           
        },

        watch: {
            pagesSelected() {
                this.fetchPost()
            },
        },

        beforeDestroy() {
            localStorage.setItem('filterList',JSON.stringify(this.filter))
        },
        
    }
</script>

<style lang="scss" scoped>

</style>